import {create} from 'zustand';

const defaultState = {
    isVisible: false,
    title: "",
    description: "",
    otpRequired: false,
    confirmText: 'Confirm',
    otpValue: "",
    onConfirm: () => {
    },
    onCancel: () => {
    }
}

const useModalStore = create((set, get) => ({
    ...defaultState,
    setOtpValue: (value) => set({otpValue: value}),
    clearModal: () => {
        set({
            ...defaultState
        })
    },
    hideModal: () => {
        set({
            isVisible: false
        })
    },
    getOtpValue: () => get().otpValue,
    isOtpRequired: () => get().otpRequired,
    setModal: ({isVisible, title, description, onConfirm, onCancel, otpRequired, confirmText}) =>
        set({
            isVisible: !!isVisible || false,
            title: title || "Confirm Action",
            description: description || "Are you sure you want to proceed?",
            otpRequired: otpRequired || false,
            confirmText: confirmText || "Confirm",
            otpValue: "",
            onConfirm: onConfirm || (() => {
            }),
            onCancel: onCancel || (() => {
                try {
                    if (this && typeof this.clearModal === 'function') {
                        this.clearModal();
                    }
                } catch (e) {
                    console.error(e)
                }
            })
        }),
}));

export default useModalStore;